import Enum from "../../../../class/Enum"

export default Enum.make({
	IBAN : "IBAN",
	GB : "GB",
	US : "US",
	CA : "CA",
	OTHER : "OTHER",
});
